import React from 'react'
import { IconButton, Grid, Tooltip } from '@mui/material'
import ListAltIcon from '@mui/icons-material/ListAlt'
import { useLang } from '~/hooks/useLang'

export default function ListHistoryButton({ hasHistory, historyUrl }) {
  const { translate } = useLang()
  const ClickOpen = () => {
    window.open(
      historyUrl,
      'window-suport, width=auto, height=600, status = no'
    )
  }

  return (
    <Grid item>
      <Tooltip
        title={translate('See Window Support')}
        componentsProps={{
          tooltip: { sx: { fontSize: '14px', padding: '6px 10px' } },
        }}
      >
        <span style={{ display: 'inline-block' }}>
          <IconButton disabled={!hasHistory} onClick={ClickOpen}>
            <ListAltIcon />
          </IconButton>
        </span>
      </Tooltip>
    </Grid>
  )
}
